export default {
    main: {
        minHeight: "calc(100vh - 202px)",
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    loading: {
        margin: "39px"
    },
    text: {

    }
}